module.exports = "query GetCreditsBalance {\n  account {\n    credits {\n      ...Amount\n    }\n  }\n}\n"